export default function () {
  document.querySelectorAll('a[href^="#"]').forEach(function (el) {
    el.addEventListener('click', function (event) {
      event.preventDefault();
      const element = document.querySelector(event.currentTarget.getAttribute('href'));
      element.scrollIntoView({behavior: 'smooth'});
      if (element.getAttribute('tabindex')) {
        element.focus();
      }
    });
  });
}